import type { PaywallPriceScenario } from "@circle-react/types";

interface StatusBadgeProperty {
  className: string;
  labelClassName: string;
  labelLocale: string;
}

const trialThenValueClassName = "!bg-blue-100 py-1 px-2";
const trialThenValueLabelClassName = "!text-blue-800 font-medium";

export const priceListProperties: Record<
  PaywallPriceScenario,
  StatusBadgeProperty | null
> = {
  trial_then_value: {
    labelLocale: "price_badge",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  trial_then_upfront_then_value: {
    labelLocale: "price_badge",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  upfront_then_trial_then_value: {
    labelLocale: "price_badge",
    className: "!bg-tertiary text-dark px-2 py-1",
    labelClassName: "!text-primary font-medium",
  },
  value: null,
  upfront_then_value: null,
};

export const previewPriceModalProperties: Record<
  PaywallPriceScenario,
  StatusBadgeProperty | null
> = {
  trial_then_value: {
    labelLocale: "free_trial",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  trial_then_upfront_then_value: {
    labelLocale: "free_trial",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  upfront_then_trial_then_value: {
    labelLocale: "paid_trial",
    className: "!bg-tertiary text-dark px-2 py-1",
    labelClassName: "!text-primary font-medium",
  },
  value: null,
  upfront_then_value: null,
};

export const previewPriceProperties: Record<
  PaywallPriceScenario,
  StatusBadgeProperty | null
> = {
  trial_then_value: {
    labelLocale: "free_trial",
    className: trialThenValueClassName,
    labelClassName: trialThenValueLabelClassName,
  },
  trial_then_upfront_then_value: {
    labelLocale: "free_trial",
    className: "!bg-blue-100 py-1  px-2",
    labelClassName: trialThenValueLabelClassName,
  },
  upfront_then_trial_then_value: null,
  value: null,
  upfront_then_value: null,
};
